// extracted by mini-css-extract-plugin
module.exports = {"section":"oI","sectionOpen":"pI","cautionBox":"qI","successBox":"rI","fade-out":"sI","failureBox":"tI"};